/**
 * @generated SignedSource<<6a4e5f6af7cdeebb1678e04a627b6fd1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedAuctionClosed_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PriceDisplay_item">;
  readonly " $fragmentType": "PdpSharedAuctionClosed_item";
};
export type PdpSharedAuctionClosed_item$key = {
  readonly " $data"?: PdpSharedAuctionClosed_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAuctionClosed_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAuctionClosed_item",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        },
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "PriceDisplay_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "e4b7501fa75d5e800863271e424b46a8";

export default node;
